import { Component, Input } from '@angular/core';
import { LanguageService } from '../../../../services/language/language.service';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

@Component({
  selector: 'app-trial-countdown-banner',
  templateUrl: './trial-countdown-banner.component.html',
  styleUrls: ['./trial-countdown-banner.component.scss'],
  standalone: false
})
export class TrialCountdownBannerComponent {
  @Input() subscriptionStatus: string | null = null;
  @Input() currentPeriodEnd: string | null = null;

  constructor(private readonly languageService: LanguageService) {}

  get isVisible(): boolean {
    return this.subscriptionStatus === 'trialing' && this.daysRemaining !== null;
  }

  get daysRemaining(): number | null {
    if (!this.currentPeriodEnd) {
      return null;
    }
    const end = Date.parse(this.currentPeriodEnd);
    if (!Number.isFinite(end)) {
      return null;
    }
    const delta = Math.ceil((end - Date.now()) / MS_PER_DAY);
    return Math.max(0, delta);
  }

  get label(): string {
    const days = this.daysRemaining ?? 0;
    const key = days === 1 ? 'usage.trial.banner_one' : 'usage.trial.banner';
    const translated = this.languageService.translate(key);
    if (translated && translated !== key) {
      return translated.replace('{{days}}', String(days));
    }
    return days === 1
      ? 'Tu trial termina en 1 dia. Cambia a un plan para no perder acceso.'
      : `Tu trial termina en ${days} dias. Cambia a un plan para no perder acceso.`;
  }

  get cta(): string {
    const key = 'usage.trial.cta';
    const translated = this.languageService.translate(key);
    return translated && translated !== key ? translated : 'Ver planes';
  }
}
